import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { motion } from 'framer-motion';
export const Deliverables = () => {
  const items = [{
    title: 'El Manual Maestro',
    desc: 'Guía paso a paso desde cero absoluto.'
  }, {
    title: 'Optimización de Perfil Imán',
    desc: 'Cómo configurar tu Instagram para que agencias te quieran contratar.'
  }, {
    title: 'El Guion Perfecto',
    desc: 'El script palabra por palabra que usamos para agendar citas sin ser pesados.'
  }, {
    title: 'Diccionario de Objeciones',
    desc: 'Qué responder cuando te dicen "no tengo tiempo" o "es caro".'
  }, {
    title: 'Hoja de Ruta de Cobro',
    desc: 'Cómo traer tus dólares a Argentina de forma legal y al mejor tipo de cambio.'
  }];
  return <AnimatedSection data-id="element-14">
      <div className="mb-16 md:mb-20" data-id="element-15">
        <span className="uppercase tracking-widest text-xs font-semibold text-ink/50 block mb-4" data-id="element-16">
          LO QUE INCLUYE EL MANUAL
        </span>
        <h2 className="text-3xl md:text-4xl font-serif text-ink" data-id="element-17">
          Todo lo que vas a recibir
        </h2>
      </div>

      <div className="max-w-4xl mx-auto" data-id="element-18">
        <div className="border-t border-ink/20" data-id="element-19">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex flex-col md:flex-row md:items-baseline gap-4 md:gap-8 py-6 border-b border-ink/20 group hover:bg-sepia/20 transition-colors px-4 -mx-4" data-id="element-20">
              <div className="font-serif text-2xl text-accent/60 w-12 flex-shrink-0" data-id="element-21">
                0{index + 1}
              </div>
              <div className="flex-grow" data-id="element-22">
                <h3 className="text-xl font-serif text-ink mb-2" data-id="element-23">
                  {item.title}
                </h3>
                <p className="font-sans text-ink/70 leading-relaxed" data-id="element-24">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </AnimatedSection>;
};